module.exports = {"id":"142754","name":"Javier Mascherano","rating":"83","photo":"./data/images/photos/4/142754.png","club":{"name":"Agents libres","logo":"./data/images/clubs/Agentslibres.png"},"positions":["DC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JavierMascherano0.json
// module id = 1945
// module chunks = 0